import { i18n } from '@/locale';

const alarmStatusMap = {
  0: '正常',
  1: '预警',
  2: '报警'
};

const runStateMap = {
  0: '未运行',
  1: '正常',
  2: '维护中',
  3: '故障',
  4: '采集基线中'
};

const faultState = {
  0: '无错误',
  1: '帧长度错误',
  2: '帧长度溢出',
  3: '帧开始标志错误',
  4: 'DSN错误',
  5: 'PID错误',
  6: 'MID错误',
  7: '有效载荷错误',
  8: 'CRC校验错误',
  9: '帧结束标志错误',
  10: '帧不可用错误'
};

const runClassMap = {
  0: 'unconnect-color',
  1: 'success-color',
  2: 'fix-color',
  3: 'fault-color',
  4: 'fix-color'
};

const alarmClassMap = {
  0: 'success-color',
  1: 'danger-color',
  2: 'danger-color'
};

export const dict = {
  alarm: alarmStatusMap,
  alarmClassMap,
  faultState
};

export const tools = {
  alarmText(val) {
    return i18n.t(alarmStatusMap[val]);
  },
  runStateText(val) {
    return i18n.t(runStateMap[val]);
  },
  faultText(val) {
    return dict.faultState[val];
  },

  alarmClass(val) {
    return alarmClassMap[val];
  },
  runClass(val) {
    return runClassMap[val];
  }
};
